import { selectors } from '../Stream';
import { getStreamId } from './helpers';
import { THREAD_MAX_DEPTH } from './constants';
export function getTotal(state, typeId, itemId, parentId) {
    const streamId = getStreamId(typeId, itemId, parentId);
    return selectors.getTotal(state, streamId);
}
export function getThreadState(state, typeId, itemId, parentId) {
    const streamId = getStreamId(typeId, itemId, parentId);
    const streamParams = selectors.getStreamParams(state, streamId);
    return {
        streamId,
        isInitialized: selectors.isInitialized(state, streamId),
        items: selectors.getItems(state, streamId),
        hasMore: selectors.hasMore(state, streamId),
        hasLess: selectors.getHasLess(state, streamId),
        isFetching: selectors.isFetching(state, streamId),
        total: selectors.getTotal(state, streamId),
        order: streamParams && streamParams.order,
        lastInsertedCommentId: streamParams && streamParams.lastInsertedCommentId,
        canPostComment: streamParams && streamParams.canPostComment,
        maxDepth: streamParams && streamParams.maxDepth || THREAD_MAX_DEPTH
    };
}

//# sourceMappingURL=selectors.js.map